 <!-- <body>
    <section>
        <div class="imgBx">
            <img src="assets/img-web/gif-deleteAccount/deleteAccount.gif" alt="GIF">
        </div>
        <div class="contentBx">
            <div class="formBx">
                <div>
                    <span>Hola</span>
                </div>
            </div>
        </div>
    </section>
</body> -->

<!-- <!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8">
        <title>Delete Account</title>
    </head>
    <body>
        <div class="wave-header">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#00A7B5" fill-opacity="1" d="M0,0L48,16C96,32,192,64,288,101.3C384,139,480,181,576,197.3C672,213,768,203,864,208C960,213,1056,235,1152,224C1248,213,1344,171,1392,149.3L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
            <h1>WAVY HEAD FOR YOUT WEBSITE</h1>
        </div>
    </body>
</html> -->

<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Delete Account</title>
</head>
<body>
    <div class="wave-header">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#00A7B5" fill-opacity="1" d="M0,0L48,16C96,32,192,64,288,101.3C384,139,480,181,576,197.3C672,213,768,203,864,208C960,213,1056,235,1152,224C1248,213,1344,171,1392,149.3L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
        <div>
            <h1>Siga los siguientes pasos para eliminar su cuenta de MiWICPR:</h1>
            <ul type="i">
                <li>• Ir la sección de <strong>Configuración</strong>.</li>
                <li>• Tap en la opción <strong>Eliminar mi cuenta</strong>.</li>
                <li>• Finalmente tap en <strong>Sí, eliminar mi cuenta</strong>.</li>
            </ul>
        </div>

        <div class="gif-container">
            <img src="assets/img-web/gif-deleteAccount/delete-account.gif" alt="GIF">
        </div>
    </div>
</body>
</html>
